export const environment = {
  production: true,
  baseApiUrl: "https://u-api.loadmanager.cloud", //'https://u-api.loadmanager.cloud', //'http://localhost:5000'
  baseAppUrl: "https://u-newbook.loadmanager.cloud",
  cookiedomain: "oltresolutions.it",
  adminRoles: ["WarehouseAdmin", "WarehouseFullAdmin"],
  loadManagerBookingUrl: 'https://u-app.loadmanager.cloud/Book',
  recaptchaAction: 'newbook_gcaptcha_uat',
  recaptchaToken: '6LdLjDAsAAAAAHIlByXkEAvIL8hUS1hqR0N8VGlG'
};
